/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CelloTokenGeneratorResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiCelloController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-cello-controller
   * @name Token
   * @request GET:/api/v1/cello/token
   */
  token = (params: RequestParams = {}) =>
    this.http.request<CelloTokenGeneratorResponse, any>({
      path: `/v1/cello/token`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static tokenPath = '/v1/cello/token'
  static tokenMethod = 'GET'
}
